import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./config";
import store from "@/store";
import _ from "lodash";
import i18n from "@/locales/i18n";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return originalPush.call(this, location).catch(err => err);
};
const WHITE_LIST = [
    "Tests",
    "Login",
    "IdentityLogin",
    "Registry",
    "Terms",
    "ResetPassword",
    "Home",
    "PlanDetail",
    "My",
    "TcmSearch"
];

const router = new VueRouter({
    mode: "history",
    routes
});
const NOT_BACK_LIST = ["Login", "IdentityLogin", "Registry", "ResetPassword"];

// Navigation Guards
router.beforeEach((to, from, next) => {
    if (from.name && !_.includes(NOT_BACK_LIST, from.name)) {
        store.commit("base/previewUrl", from.path);
    }
    document.title = i18n.t(_.get(to, "meta.title", "common.title.default")) as string;
    if (_.includes(WHITE_LIST, to.name) || store.getters["login/loggedIn"]) {
        next();
    } else {
        next("/login");
    }
});

export default router;
